<template>

    <div class="card-radio-group">
        <div class="card-radio">
            <input
                :id="inputHtmlId"
                type="radio"
                :name="name"
                :value="value"
                ref="radio"
                @input="input"
            >
            <label class="text-base text-black" :for="inputHtmlId">
                <slot></slot>
            </label>
        </div>
    </div>

</template>

<script>
    import _ from 'lodash'

    export default {
        props: ['name', 'value', 'checkedValue'],
        data() {
            return {
                inputHtmlId: _.uniqueId('card-radio-')
            }
        },
        mounted() {
            this.$refs.radio.checked = this.value === this.checkedValue
        },
        watch: {
            value: {
                handler(value) {
                    this.$refs.radio.checked = value === this.checkedValue
                },
            }
        },
        methods: {
            input() {
                this.$emit('input', this.checkedValue)
            },
        }
    }
</script>

<style lang="scss">
    .card-radio-group {
        .card-radio {
            display: flex;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        label {
            display: block;
        }

        .card-radio-title {
            display: block;
        }

        .card-radio-text {
            display: block;
        }

        [type="radio"]:checked,
        [type="radio"]:not(:checked) {
            position: absolute;
            left: -9999px;
        }
        [type="radio"]:checked + label,
        [type="radio"]:not(:checked) + label
        {
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            line-height: 20px;
            display: inline-block;
        }

        .card-radio-lg {
            [type="radio"]:checked + label,
            [type="radio"]:not(:checked) + label {
                padding-left: 36px;
            }
        }

        [type="radio"]:checked + label:before,
        [type="radio"]:not(:checked) + label:before {
            content: '';
            position: absolute;
            left: 0;
            top: 1px;
            width: 18px;
            height: 18px;
            border: 1px solid #1D5091;
            border-radius: 100%;
            background: #fff;
        }

        .card-radio-lg {
            [type="radio"]:checked + label:before,
            [type="radio"]:not(:checked) + label:before {
                height: 24px;
                width: 24px;
            }

            label {
                padding-top: 4px;
            }
        }

        [type="radio"]:checked + label:after,
        [type="radio"]:not(:checked) + label:after {
            content: '';
            width: 12px;
            height: 12px;
            background: #1D5091;
            position: absolute;
            top: 4px;
            left: 3px;
            border-radius: 100%;
            -webkit-transition: all 0.2s ease;
            transition: all 0.2s ease;
        }

        .card-radio-lg {
            [type="radio"]:checked + label:after,
            [type="radio"]:not(:checked) + label:after {
                top: 4px;
                left: 4px;

                width: 16px;
                height: 16px;
            }
        }

        [type="radio"]:not(:checked) + label:after {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0);
        }
        [type="radio"]:checked + label:after {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }
</style>